import { type ViewStyle } from "react-native";
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withRepeat,
  withTiming,
  Easing,
} from "react-native-reanimated";
import { useEffect } from "react";
import { colors } from "../theme/tokens";

type Props = {
  width: number | `${number}%`;
  height: number;
  radius?: number;
  circle?: boolean;
  style?: ViewStyle;
};

export function MoonSkeleton({ width, height, radius, circle, style }: Props) {
  const opacity = useSharedValue(0.3);

  useEffect(() => {
    opacity.value = withRepeat(
      withTiming(0.7, { duration: 800, easing: Easing.inOut(Easing.ease) }),
      -1,
      true,
    );
  }, [opacity]);

  const animatedStyle = useAnimatedStyle(() => ({
    opacity: opacity.value,
  }));

  const size = circle
    ? Math.max(typeof width === "number" ? width : height, height)
    : undefined;

  return (
    <Animated.View
      style={[
        {
          width: circle ? size : width,
          height: circle ? size : height,
          borderRadius: circle ? size! / 2 : (radius ?? 6),
          backgroundColor: colors.border,
        },
        style,
        animatedStyle,
      ]}
    />
  );
}
